/* 🤖 this file was generated by svg-to-ts */
export const matIconFormatBold: {
  name: 'format-bold';
  data: string;
} = {
  name: 'format-bold',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"/></svg>`
};
